<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img16.jpg"/></p>
<p class="chap"><a id="ch7"></a>LOST COLONY II, 1587</p>
<p class="noindent"><span class="big">I</span>n 1587, England made a second attempt to create a military outpost on the outer banks of today’s North Carolina. John White led this endeavor; to create a permanent settlement, he brought families with him, including several pregnant women. White’s own granddaughter, Virginia Dare, was the first English child born in the new world.</p>
<p class="indent">Of the Native American confederation in the area, only the Croatoan tribe remained on good terms with the English. So White became convinced that only a substantial resupply could insure the colony’s survival. Later in 1587, he returned to England to organize aid for Roanoke. He was delayed during his trip back to America by an attack of the Spanish Armada (1588) and did not arrive back in Roanoke Island until August 1590. He found the settlement deserted. Only the cryptic word <i>Croatoan</i> carved in a tree offered a clue as to the fate of the Lost Colony. <span class="color">(04-016, 04-015, 04-016)</span></p>
<p class="image"><img alt="image" src="images/img17.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter007.vue?d6b3e880